var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.module.resource && _vm.module.resource.content && _vm.module.resource.content.iframeString)?_c('div',{staticClass:"module-iframe"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.module.resource.content.iframeString)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }